import { Box, Flex } from 'dash-ui';
import styled from 'styled-components';

export const StyledBox = styled(Box)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.n20};
`;

export const TopBarWrapper = styled(Flex)<{ top?: number }>`
  @media ${({ theme }) => theme.devices.mobile} {
    align-items: flex-start;
    flex-direction: column;
  }
`;
